export enum EventCategory {
    Live,
    Complementar,
    Monitoria,
    Theory,
    Resolution,
    SalaVirtual
}
